import loadable from '../../utilities/loadable'

export const ComposerRoot = loadable(() => import('./Composer/ComposerRoot'))
export const SplitViewRoot = loadable(() => import('./SplitView/SplitViewRoot'))
